export const CAMPAIGN_UPDATE_FORM_TYPE = {
  NORMAL: 'NORMAL',
  MASTER: 'MASTER',
};
